import { LonaWebComponent, html } from "@tento-ui/component";
import { component } from "@tento-ui/component-decorators";
import { css } from "@tento-ui/component-styles";
import { PropertyListItem } from "@tento-ui/components/input/property-list";
import { DomUtils } from "@tento-ui/dom";
import type { SheetId } from "@tento-lona/sheets";

@component({ name: "debug-resolved-sheet-panel" })
export class DebugResolvedSheetPanel extends LonaWebComponent {
  private $info: HTMLElement = this.$("info");

  bind(props: DebugResolvedSheetPanel.Props): this {
    const data = props;
    DomUtils.clearChildren(this.$info);

    if (data.state) {
      this.$info.appendChild(
        PropertyListItem.makeWith({ label: "State", value: data.state }),
      );
    }

    if (data.lookupKey) {
      this.$info.appendChild(
        PropertyListItem.makeWith({
          label: "Lookup Key",
          value: data.lookupKey,
        }),
      );
    }

    if (data.ownerId) {
      this.$info.appendChild(
        PropertyListItem.makeWith({ label: "Owner", value: data.ownerId }),
      );
    }

    if (data.userSheetId) {
      this.$info.appendChild(
        PropertyListItem.makeWith({
          label: "Sheet ID",
          value: data.userSheetId.toString(),
        }),
      );
    }

    return this;
  }

  static $styles = [
    ...PropertyListItem.$styles,
    css`
      :host {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
        max-width: 400px;
      }

      #info {
        --label-min-width: 56px;
        --plist-height: 24px;
      }
    `,
  ];

  static $html = html`
    <std-col id="info"></std-col>
  `;
}

export namespace DebugResolvedSheetPanel {
  export type Props = {
    state?: Option<string>;
    lookupKey?: Option<string>;
    ownerId?: Option<string>;
    userSheetId?: Option<SheetId>;
  };
}
